import {BaseContainerModel} from '../../../base-container.model';
import {bl_del_slot_gen_doc_link_RowClass } from '../../../../dbschema';

export class DeliveryPlanSlotGendocLinkContainer extends BaseContainerModel {
    bl_del_slot_gen_doc_links: bl_del_slot_gen_doc_link_RowClass[] = [];
}
